import "../../styles/style"
import "../../safe-area/style"
import "../index.scss"
